import styled from "@emotion/styled";

import { ThemeMode } from "../../context/ThemeContext";

interface NewPatientWrapperProps {
  mode: ThemeMode;
}

export const NewPatientWrapper = styled.div<NewPatientWrapperProps>`
  box-sizing: border-box;
  margin: 0 auto;
  background: ${({ mode }) => (mode === "dark" ? "#353944" : "white")};
  border-radius: 20px;
  padding: 40px 0 1rem;
  color: ${({ mode }) => (mode === "dark" ? "#F0F0F0" : "#0D0A2C")};
  overflow-x: hidden;
  text-align: center;
  position: relative;
  width: 100%;
  max-width: 891px;
  .close-button {
    position: absolute;
    background-color: transparent;
    cursor: pointer;
    border: none;
    width: 31px;
    height: 30px;
    margin: 0;
    top: 40px;
    right: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg path {
      fill: ${({ mode }) => (mode === "dark" ? "#F0F0F0" : "#0D0A2C")};
      transition: fill 0.2s ease;
    }

    &:hover svg path {
      fill: ${({ mode }) => (mode === "dark" ? "#BADAFF" : "#236BCF")};
    }
  }
  form {
    margin: 0 auto;
    max-width: 657px;

    .MuiFilledInput-root {
      box-shadow: none;
      background-color: ${({ mode }) =>
        mode === "dark" ? "#2B2F3A" : "#F0F0F0"};
      border-radius: 10px;
      height: 62px;

      &:hover {
        background-color: ${({ mode }) =>
          mode === "dark" ? "#2B2F3A" : "#F0F0F0"};
        box-shadow: none;
      }

      &:focus-within {
        background-color: ${({ mode }) =>
          mode === "dark" ? "#2B2F3A" : "#F0F0F0"};
      }

      input,
      .MuiSelect-select {
        background-color: ${({ mode }) =>
          mode === "dark" ? "#2B2F3A" : "#F0F0F0"};
        color: ${({ mode }) => (mode === "dark" ? "#F0F0F0" : "#0D0A2C")};
        font-family: "Montserrat", sans-serif;
        font-size: 16px;
        font-weight: 400;
      }

      .MuiSelect-icon path {
        fill: ${({ mode }) => (mode === "dark" ? "#F0F0F0" : "#0D0A2C")};
      }
    }

    .MuiInputLabel-root {
      color: ${({ mode }) => (mode === "dark" ? "#F0F0F0" : "#0D0A2C")};
      font-family: "Montserrat", sans-serif;
      font-size: 16px;
      font-weight: 400;
    }

    h3 {
      color: ${({ mode }) => (mode === "dark" ? "#F0F0F0" : "#0D0A2C")};
      font-family: "Montserrat", sans-serif;
      font-size: 23px;
      font-weight: 700;
      margin-bottom: 20px;
    }
  }
  button[type="submit"] {
    width: 295px !important;
    height: 54px !important;
    background: ${({ mode }) =>
      mode === "dark" ? "#236BCF" : "#1A509B"} !important;
    border-radius: 10px !important;
    color: #f0f0f0 !important;
    font-family: "Montserrat", sans-serif !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    text-transform: none !important;
    margin-top: 20px !important;

    &:hover {
      background: ${({ mode }) =>
        mode === "dark" ? "#1A509B" : "#13407C"} !important;
    }
  }
`;
